export default __webpack_public_path__ + "static/media/close-dropdown-icon.95e667a0.svg";